import { readonly, watch } from 'vue';
import { useProduct } from '~/modules/product/composables/useProduct';
import { useBrand } from '~/composables/useBrand';
import usePriceLatchkey from './usePriceLatchkey';
import useSizeLatchkey from './useSizeLatchkey';
import useColorLatchkey from './useColorLatchkey';
import LatchkeyParser from '../parsers/ConsolidatedLatchkeyParser';
import useUpcLatchkey from './useUpcLatchkey';
import useImageLatchkey from './useImageLatchkey';
import useLatchkey from './useLatchkey';

// Currently only supports 1 latchkey product per page. TODO fix if needed
// TODO optimize so doesn't recalculate on each instance

function useConsolidatedLatchkey() {
  const { productData: product, productId } = useProduct();

  const parsed = LatchkeyParser(product);
  const { latchKeyProductIdsByGroup, latchKeyGroups, selectedLatchkey } = useLatchkey();

  const { sizeProps, selectedSizeId, selectedSize, sizes } = useSizeLatchkey(productId, readonly(selectedLatchkey), parsed);
  const { colorProps, selectedColorId, selectedColor, colors } = useColorLatchkey(productId, readonly(selectedLatchkey), parsed);
  const upcData = useUpcLatchkey(productId, readonly(selectedLatchkey), parsed);

  const images = useImageLatchkey(product, selectedColor, upcData.selectedUpcId, selectedLatchkey, latchKeyProductIdsByGroup);

  const selectedPrice = usePriceLatchkey({
    id: productId,
    product,
    ...parsed,
    selectedLatchkey: readonly(selectedLatchkey),
    selectedUpcId: upcData.selectedUpcId,
    selectedColor,
    selectedSize,
  });

  // TODO remove once mcom xapi is migrated to use same structure as bcom
  const { isMcom } = useBrand();
  if (isMcom) {
    watch(selectedSize, (size) => {
      selectedColorId.value = Object.keys(size?.colorToSizes)[0];
    });
  }

  return {
    colors,
    sizes,
    latchKeyGroups,
    selectedColor,
    selectedSize,
    selectedSizeId,
    selectedColorId,
    selectedPrice,
    selectedLatchkey,
    colorProps,
    sizeProps,
    upcData,
    images,
  };
}

export default useConsolidatedLatchkey;
